// extracted by mini-css-extract-plugin
var _1 = "TableUserCell-moduleuserValue__xolos UserMultiValueContent-moduleUserMultiValue__sCajR";
export { _1 as "userValue" }
